import React from 'react';
import { AutoComplete, Button, Form, Icon, Select } from 'antd';
import PropTypes from 'prop-types';
import { getSubFormFieldByType, sanitizeFieldName } from '../../util/methods';
import ComplaintModal from "../ComplaintModal";
import DocumentList from "../../components/DocumentList";

class SubList extends React.Component {

  id = 0;

  state = {
    keys: [],
    fuelMeterStdRateName: [],
    fuelMeterStdRateQty: []
  };

  componentDidMount() {
    const { data = [{}] } = this.props;
    this.setState({
      keys: data,
    });

    if (this.props && this.props.data && this.props.other && this.props.other.key && this.props.other.key === 'standardFuelConsumptionRate') {
      const fuelMeterStdRateName = []
      const fuelMeterStdRateQty = []
      this.props.data.forEach((doc, inx) => {
        fuelMeterStdRateName[inx] = doc.perType && doc.perType.name
        fuelMeterStdRateQty[inx] = doc.fuelQty
      })
      this.setState({
        fuelMeterStdRateName,
        fuelMeterStdRateQty
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
      this.setState({
        keys: nextProps.data,
      });
    }
  }

  remove = (index, pindex = 0) => {
    const { keys } = this.state;
    const { form, item } = this.props;
    const { field } = item;
    if (keys.length === 0) {
      return;
    }

    let val = form.getFieldValue(field);

    if (!Array.isArray(val)) {
      const assets = form.getFieldValue(`assets`); // it was done by other developer, so i need to bypass
      val = assets && assets[`${pindex}`] && assets[`${pindex}`][`${field}`];
    }

    val = Array.isArray(val) ? val : [];
    val.splice(index, 1);

    keys.splice(index, 1);
    const fuelMeterStdRateName = [...this.state.fuelMeterStdRateName];
    const fuelMeterStdRateQty = [...this.state.fuelMeterStdRateQty];
    fuelMeterStdRateName.splice(index, 1);
    fuelMeterStdRateQty.splice(index, 1);
    for (let i = 0; i < val.length; i++) {
      Object.keys(item.schema).map((item, index) => {
        form.setFieldsValue({
          [`${field}[${i}][${item}]`]: val[i][item],
        });
      });
    }
    this.setState({
      keys: keys,
      fuelMeterStdRateName,
      fuelMeterStdRateQty
    });
  };

  add = () => {
    if (this.shouldHideAddAction()) {
      return;
    }
    const { item: { field } } = this.props;
    const { keys } = this.state;
    keys.push(`${field}${this.id++}`);
    this.setState({
      keys: keys,
    });
  };

  fuelTypeRateSelectHandle = (index, meterId, meters) => {
    const meterData = (meters || []).filter(m => m._id === meterId)
    const fuelMeterRateName = [...this.state.fuelMeterStdRateName];
    fuelMeterRateName[index] = `${(meterData && meterData[0] && meterData[0]['name'])}`
    this.setState({ fuelMeterStdRateName: fuelMeterRateName })
  }

  fuelRateInputHandle = (index, rate) => {
    let fuelMeterRateQty = [...this.state.fuelMeterStdRateQty];
    console.log(fuelMeterRateQty);
    fuelMeterRateQty[index] = Number(rate)
    console.log(fuelMeterRateQty);

    this.setState({ fuelMeterStdRateQty: fuelMeterRateQty });
  }

  getValueId = (value) => {
    if (!value) return null;
    if (typeof value === 'string' || typeof value === 'number') return `${value}`;
    if (typeof value === 'object') {
      const id = value._id || value.id;
      if (id) return `${id}`;
      if (value.toString && value.toString() !== '[object Object]') {
        return `${value.toString()}`;
      }
    }
    return null;
  }

  getRows = () => {
    const { form, item, data = [] } = this.props;
    const values = form.getFieldValue(item.field);
    return Array.isArray(values) ? values : data;
  }

  getSelectedPerTypeIds = () => {
    const rows = this.getRows() || [];
    const selectedIds = [];
    rows.forEach((row) => {
      const perTypeId = this.getValueId(row && row.perType);
      if (perTypeId && !selectedIds.includes(perTypeId)) {
        selectedIds.push(perTypeId);
      }
    });
    return selectedIds;
  }

  getAvailableMetersForIndex = (index) => {
    const { other } = this.props;
    const availableMeters = other && other.availableMeters;
    if (!availableMeters) {
      return null;
    }

    if (!(other && other.enforceUniquePerType)) {
      return availableMeters;
    }

    const rows = this.getRows() || [];
    const currentId = this.getValueId(rows[index] && rows[index].perType);
    const selectedIds = this.getSelectedPerTypeIds();

    return availableMeters.filter((meter) => {
      const meterId = this.getValueId(meter);
      if (!meterId) return false;
      return meterId === currentId || !selectedIds.includes(meterId);
    });
  }

  shouldHideAddAction = () => {
    const { hideAddButton, other } = this.props;
    if (hideAddButton) {
      return true;
    }
    if (!(other && other.limitByAvailableOptions)) {
      return false;
    }
    const options = other.availableMeters || [];
    if (!options.length) {
      return true;
    }
    return this.state.keys.length >= options.length;
  }

  render() {
    const { form, item, data = [], hideAddButton = false, resource, superMaster, subMaster } = this.props;
    const { field } = item;
    const { getFieldDecorator, setFieldsValue } = form;
    const { keys } = this.state;
    const shouldHideAddAction = this.shouldHideAddAction();
    const style = {
      marginTop: '10px',
      border: '1px dashed #000',
      padding: '20px',
      borderRadius: '9px',
    };

    const formItems = keys.map((k, index) => (

      <div key={index} style={style}>
        {
          Object.keys(this.props.item.schema).map((fieldName, innerIndex) => {
            if (fieldName === 'leasingAssetx' || fieldName === 'suspendedAssetx') {
              return <Form.Item key={`${index}${innerIndex}`} label={'Enter Asset'} style={{ width: '100%' }}>
                {getFieldDecorator(`assets.${field}[${index}][${item.schema[fieldName].field}]`, {
                  initialValue: data[index] && data[index][fieldName] && data[index][fieldName].assetCode,
                })
                  (<AutoComplete onSearch={this.props.assetSearch}
                    placeholder={'Asset Code'}
                    disabled={(this.props.title === 'EDIT' && data[index] && data[index][fieldName]) ? true : false}>
                    {
                      (this.props.assetData || []).map(item => (
                        <Select.Option key={item._id} value={item._id}>{item.assetCode}</Select.Option>))
                    }
                  </AutoComplete>)}
              </Form.Item>
            } else if (fieldName === 'suspensionDocumentsx') {

              return <DocumentList match={this.props.match} history={this.props.history}
                key={item.schema.suspensionDocuments} item={item.schema.suspensionDocuments}
                form={form} data={data[item.schema.suspensionDocuments]}
                subDocumentFilters={this.props.subDocumentFilters}
                getDocumentData={this.props.getDocumentData} />

            } else if (fieldName === 'complaint') {
              return <ComplaintModal history={this.props.history} match={this.props.match} key={item} item={item}
                form={form} data={[]} getComplaintData={this.props.getComplaintData}
                complaints={this.props.complaints} />

            } else if (fieldName === 'perType') {
              return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, {
                title: 'CREATE',
                resource,
                superMaster: (superMaster || false),
                subMaster: (subMaster || false),
                setFieldsValue,
                parent: this.props.parent,
                selectData: this.props.selectData,
                availableMeters: this.getAvailableMetersForIndex(index),
                isSelectable: !!this.props.selectData,
                onChange: (a, b) => this.fuelTypeRateSelectHandle(index, a, b)
              });
            } else if (this.props.other && this.props.other.key && this.props.other.key === 'standardFuelConsumptionRate' && fieldName === 'fuelQty') {
              return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, {
                title: 'CREATE',
                resource,
                superMaster: (superMaster || false),
                subMaster: (subMaster || false),
                setFieldsValue,
                parent: this.props.parent,
                selectData: this.props.selectData,
                isSelectable: !!this.props.selectData,
                onChange: (a) => this.fuelRateInputHandle(index, a)
              });
            }
            else {
              return getSubFormFieldByType(item.schema[fieldName], getFieldDecorator, data[index], `${index}${innerIndex}`, field, index, {
                title: 'CREATE',
                resource,
                superMaster: (superMaster || false),
                subMaster: (subMaster || false),
                setFieldsValue,
                parent: this.props.parent,
                selectData: this.props.selectData,
                isSelectable: !!this.props.selectData,
              });
            }
          })
        }
        {
          (this.props.other && this.props.other.key && this.props.other.key === 'standardFuelConsumptionRate' && this.state.fuelMeterStdRateName[index] && this.state.fuelMeterStdRateQty[index]) ?
            <div style={{ color: 'red' }}>Ltr/{this.state.fuelMeterStdRateName[index]} = {this.state.fuelMeterStdRateQty[index]} & {this.state.fuelMeterStdRateName[index]}/Ltr = {(1 / Number(this.state.fuelMeterStdRateQty[index])).toFixed(2)}</div>
            : ''
        }
        {index >= 0 && !hideAddButton ? (
          <Icon
            className="dynamic-delete-button"
            type="minus-circle-o"
            onClick={() => this.remove(index, this.props.pindex)}
          />
        ) : null}
      </div>
    ));

    return (
      <div>
        {formItems}
        {
          shouldHideAddAction ? <br /> : <Form.Item>
            <Button type="dashed" onClick={this.add} style={{ width: '60%', marginTop: '15px' }}>
              <Icon type="plus" /> Add {sanitizeFieldName(item.field)}
            </Button>
          </Form.Item>
        }

      </div>

    );
  }
}

export default SubList;
SubList.defaultProps = {};

SubList.propTypes = {
  item: PropTypes.object,
};
